import { Component, HostListener, OnInit } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { UserData } from './shared/service/UserService';
import { NavigationEnd, Router } from '@angular/router';
import { CardService } from './card/card.service';
import * as _ from 'underscore';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { ApplicationConfiguration } from './app.config';
import { BuildInfo } from 'environments/version';
import { Contract } from './shared/model/contract.model';
import { EventEmitterService } from '../app/shared/service/EventEmitterService';
import { ApiService } from './modules/shared/services/api.service';
import { AuthUserService } from './modules/shared/services/auth-user.service';
import { HelperService } from './modules/shared/services/helper.service';
import { filter } from 'rxjs/operators';
import { ConfigService } from './config';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core'; //SG-6756
import { Keepalive } from '@ng-idle/keepalive';
import { CommonAPIService } from './modules/shared/services/common-api.service';
import { MatDialog } from '@angular/material/dialog';
import { RowDeleteDialogComponent } from './modules/main/content-management/modules/row-delete-dialog/row-delete-dialog.component';
import { TabService } from './shared/service/TabService';
import { Location } from '@angular/common';
import { ConsoleTriggerService } from './shared/service/console-trigger.service';
import { ReactMobileService } from './modules/shared/services/react-mobile.service';
import { setCurrentUserEmailCache } from './configuration/training-material/email-notification.service';
declare let gtag: Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public tabCount: number; // SG-7344
  public menuMode = 'static';
  menuActiveIndex = 0;
  public menuActive = true;
  public topbarMenuActive = false;
  activeTopbarItem: Element;
  menuClick: boolean;
  menuButtonClick: boolean;
  liveSessionStatus = '';
  answerCategory = '';
  previous_route = '';
  topbarMenuButtonClick: boolean;
  resetMenu: boolean;
  menuHoverActive: boolean;
  firstName: string;
  lastName: string;
  email: string;
  userName: string;
  apikey: string;
  userRole: string;
  private role_VMT: any;
  private role_VAV: any;
  role_UMT: any;
  role_FLXT: any;
  role_APPL: any;
  role_ANLT: any;
  role_FEEDB: any;
  public subRole_VMT: any;
  public subRole_VAV: any;
  rolesFlag: boolean;
  tradeMarkText: String;
  copyRightText: String;
  versionText: string;
  public noAccessMessage: string = '';
  public noAccessForm: FormGroup;
  public msgCtrl: AbstractControl;
  organizationDataList: any = [];
  isUserManagement: boolean = false;
  model;
  activeContentManagementMenu = false;
  activeAppLibMenu = false;
  activeAnalyticsMenu = false;
  hideFooter = false;
  hideTopbar = false;
  blockScreen = false;
  singleOrgAppFlag: boolean = true;
  public currentOrganization: any = {};
  orgId: any;
  isFEEDB: boolean = false;
  isANLT: boolean = false;
  logoURL = "assets/img/strat-logo.png";

  contracts: Contract[];
  version;
  roles;
  nav = true;
  token;
  tokenId;
  isTeamMember: boolean = false;
  isCard: boolean = false;
  public isMatchGame: boolean = false;
  public isWordGame: boolean = false;
  public isTrivia: boolean = false;
  public isCategorize: boolean = false;
  isHeaderFooter: boolean = false;
  isCreator: boolean = false;
  CMSelectedTab = ''
  googleAnalyticsConfig: any
  private inactivityTimeout: any;
  private readonly MAX_INACTIVITY_SECONDS: number = 900;// if 15min not active on windows system logout autometically SG-6756
  gameOrder: any;
  constructor(
    private consoleToggleService: ConsoleTriggerService,
    private location: Location,
    private keycloakService: KeycloakService,
    private tabService: TabService,
    private dialog: MatDialog,
    private router: Router,
    private cardService: CardService,
    private _sanitizer: DomSanitizer,
    private fb: FormBuilder,
    public api: ApiService,
    private eventEmitterService: EventEmitterService,
    private config: ConfigService,
    private idle: Idle,
    private keepalive: Keepalive,
    private helperService: HelperService,
    private commonAPIService: CommonAPIService,
    private authUserService: AuthUserService,
    private reactmobileservice: ReactMobileService) {
    this.reactmobileservice.responseFromWeb("App component constructor start", false, false, true);
    this.checkForDevice();
    const breadcrumbArray: any[][] = [];
    localStorage.setItem('breadcrumbArray', JSON.stringify(breadcrumbArray));
    //start SG-6756
    // sets an idle timeout of 10 minutes
    // idle.setIdle(1200);//20minutes
    idle.setIdle(18000);//5h
    // sets a timeout period of 5 minutes (idle timeout warning period)
    idle.setTimeout(5);
    // sets the default interrupts (like clicks, scrolls, touches to reset idle)
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => console.log('No longer idle.'));
    idle.onTimeout.subscribe(() => {
      console.log('Timed out!');
      localStorage.setItem('logout-event', Date.now().toString());
      // }
      this.api.notifyError('Your session got expired, please login again to continue.');

      // window.alert("Your session got expired, please login again to continue.")
      if(this.helperService.getMobileLoginData()) {
        this.reactmobileservice.responseFromWeb('Your session got expired, please login again to continue.', false, true, false);
      } else {
        this.doLogout();
      }
      // perform logout or other actions here
    });
    idle.onIdleStart.subscribe(() => console.log('You have gone idle!'));
    idle.onTimeoutWarning.subscribe((countdown) => console.log('You will time out in ' + countdown + ' seconds!'));

    // sets the ping interval to 15 seconds
    keepalive.interval(5);

    keepalive.onPing.subscribe(() => console.log());
    // Listen for tab visibility changes
    // document.addEventListener('visibilitychange', () => {
    //   if (document.visibilityState === 'visible') {
    //     // User switched back to the tab
    //     idle.watch();
    //   } else {
    //     // User switched out of the tab
    //     idle.stop();
    //   }
    // });
    idle.watch();
    //end SG-6756
    //this.resetInactivityTimer();
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localStorage.setItem('timeZone', userTimezone);
    if (window.location.href.includes('multiGamePlay') || window.location.href.includes('match-game') || window.location.href.includes('word-game') || window.location.href.includes('quizitive') ||
      window.location.href.includes('match-game-share') || window.location.href.includes('word-game-share') || window.location.href.includes('quizitive-game-share') || window.location.href.includes('categorize-game')
      || window.location.href.includes('match-game-live-sessions') || window.location.href.includes('word-game-live-sessions') || window.location.href.includes('live-session') || window.location.href.includes('share'))
      this.isHeaderFooter = true;
  }

  async ngOnInit() {
    const logoutEvent = localStorage.getItem('pricing-logout-event');
    let email = localStorage.getItem('email');
    if (logoutEvent && email && email == "stratagem101@rigil.com") {
      this.logmeout();
    }
    this.consoleToggleService.disableConsoleInProduction();
    window.speechSynthesis.cancel();
    this.tabService.tabCount$.subscribe(count => { // SG-7344
      this.tabCount = count;
    });

    this.config.getConfigNew().subscribe(config => {
      this.googleAnalyticsConfig = config.googleAnalytics;

    });
    this.setUpAnalytics();
    //SG-8402 In mobile device redirect to dashboard is disabled
    if (!this.helperService.getIsMobileDevice() && (window.location.href.includes('main/applibrary') || window.location.href.includes('main/content-management') || window.location.href.includes('main/memberTeams') || window.location.href.includes('main/analytics') || window.location.href.includes('main/lrs-analytics') || window.location.href.includes('main/consolidated-analytics') || window.location.href.includes('main/member-consolidated-analytics') || window.location.href.includes('main/member-game-drilldown') || window.location.href.includes('main/member-performance-app-drilldown') || window.location.href.includes('main/folderAnalytics') || window.location.href.includes('main/practiceSet/analytics') || window.location.href.includes('main/user/details') || window.location.href.includes('main/feedback') || window.location.href.includes('main/feedback/organizations') || window.location.href.includes('main/organization'))) {
      this.nav = false;
      this.api.nav = false;
      this.router.navigate(['/main/content-management/dashboard']); // SG-7385
    }
    this.router.events.subscribe(next => {
      if (window.location.href.includes('main/applibrary') || window.location.href.includes('main/content-management') || window.location.href.includes('main/memberTeams') || window.location.href.includes('main/configuration') || window.location.href.includes('main/analytics') || window.location.href.includes('main/lrs-analytics') || window.location.href.includes('main/consolidated-analytics') || window.location.href.includes('main/member-consolidated-analytics') || window.location.href.includes('main/member-game-drilldown') || window.location.href.includes('main/member-performance-app-drilldown') || window.location.href.includes('main/consolidated-game-drilldown') || window.location.href.includes('main/consolidated-performance-drilldown') || window.location.href.includes('main/folderAnalytics') || window.location.href.includes('main/practiceSet/analytics') || window.location.href.includes('main/user/details') || window.location.href.includes('main/feedback') || window.location.href.includes('main/feedback/organizations') || window.location.href.includes('main/organization')) {
        this.nav = false;
        this.api.nav = false;
      } else {
        this.nav = false;
        this.api.nav = true;
      }
    });
    this.getTokenData()


    if (window.location.href.includes('multiGamePlay')) {
      let byUserMousemove: boolean = false
      document.body.addEventListener("mousemove", function (e) {
        byUserMousemove = true
      })
      setInterval(() => {
        if (byUserMousemove) { this.getTokenData(); byUserMousemove = false }
      }, 295000)
    }
  }

  async getTokenData() {
    //start SG-8399
    if (this.helperService.getIsMobileDevice() && UserData.token) {
      // Mobile device authenticated bypass Keycloak entirely
      return;
    }
    //end SG-8399
    if (await this.keycloakService.isLoggedIn()) {
      let keycloak = await this.keycloakService.getKeycloakInstance();
      this.firstName = keycloak.tokenParsed.given_name;
      this.lastName = keycloak.tokenParsed.family_name;
      this.email = keycloak.tokenParsed.email;
      localStorage.setItem('email', this.email);
      if (window.location.href.includes('quizitive') == false && window.location.href.includes('multiGamePlay') == false) {
        this.helperService.loadScript('g-analytics');
        this.helperService.loadScript('pathscript')

      }
      this.userName = keycloak.tokenParsed.preferred_username; //MARK: Changed by Ishant from  keycloak.tokenParsed.given_name
      this.roles = keycloak.realmAccess.roles;
      this.tokenId = keycloak.token;
      UserData.token = keycloak.token;
      // UserData.token = keycloak.idToken;
      if (window.location.href.includes('match-game'))
        this.isMatchGame = true;
      if (window.location.href.includes('word-game'))
        this.isWordGame = true;
      if (window.location.href.includes('quizitive') || window.location.href.includes('multiGamePlay'))
        this.isTrivia = true;
      if (window.location.href.includes('categorize-game'))
        this.isCategorize = true;
      this.onLoggedin();
    } else {
      this.isMatchGame = true;
      this.isWordGame = true;
      this.isCategorize = true;
    }
  }

  setUpAnalytics() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {

        gtag('config', this.googleAnalyticsConfig ? this.googleAnalyticsConfig.trackingId : '',
          {
            page_path: event.urlAfterRedirects
          }
        );
      });
  }
  async doLogout() {
    const logoutEvent = localStorage.getItem('logout-event');

    const currentURL = window.location.href;
    let baseURL;
    if (currentURL.includes('#')) {
      baseURL = currentURL.substring(0, currentURL.indexOf('#'));
    } else {
      baseURL = currentURL;
    }
    let redirectPath = '#/main/content-management/dashboard';
    const redirectURI = baseURL;
    const authenticated = await this.keycloakService.isLoggedIn();
    if (authenticated) { //SG-6756
      // User is logged in, proceed with logout
      await this.keycloakService.logout(redirectURI);
    }
  }

  public Add(a: number, b: number): number {
    return a + b;
  }

  onLoggedin() {
    if (this.location.path().includes('/main/configuration')) {
      this.router.navigate(['/main/content-management/dashboard']);
    }
    this.clearAppLocalStorage();
    this.cardService.user().subscribe(data => {
      let data1 = JSON.parse(JSON.stringify(data));
      if (data1 && this.tokenId) {
        this.isCard = true;
        data1.token = this.tokenId;
        // localStorage.setItem('isLoggedin', JSON.stringify(data));
        localStorage.setItem('organizationId', data1.organizationId)
        UserData.organizationId = data1.organizationId;
        if (data1.singleOrgApp)
          UserData.singleOrgApp = data1.singleOrgApp;
        UserData.roles = data1.roles;
        UserData.subRoles = data1.subRoles;
        UserData.currentOrganization.id = UserData.organizationId;
        localStorage.setItem('Role_FEEDB', null);
        localStorage.setItem('isUserManagement', JSON.stringify(false));
        this.showAnalytics = false;
        if (data1.roles && data1.roles.length > 0) {
          _.each(data1.roles, (objs) => {
            let obj: any = objs;
            if (obj.permission_code == "FLXT")
              localStorage.setItem('Role_FLXT', obj.permission_code);
            if (obj.permission_code == "UMT")
              localStorage.setItem('Role_UMT', obj.permission_code);
            if (obj.permission_code == "ANLT")
              localStorage.setItem('Role_ANLT', obj.permission_code);
            if (obj.permission_code == "APPL")
              localStorage.setItem('Role_APPL', obj.permission_code);
            if (obj.permission_code == "FEEDB")
              localStorage.setItem('Role_FEEDB', obj.permission_code);
          });
        }
        if (data1.subRoles && data1.subRoles.length > 0) {
          _.each(data1.subRoles, (objs) => {
            let obj: any = objs;
            if (obj.permission_code == "VMT")
              localStorage.setItem('SubRole_VMT', obj.permission_code);
            if (obj.permission_code == "VAV")
              localStorage.setItem('SubRole_VAV', obj.permission_code);
          });
        }
        this.helperService.userData$.next(UserData);
        this.refreshData();
      }
    });
  }

  onlyGame() {
    this.isMatchGame = false;
    this.isWordGame = false;
    this.isTrivia = false;
    this.isCategorize = false;
  }
  callContentManagment(name: string) {
    this.eventEmitterService.onFirstComponentButtonClick(name);
  }

  public refreshData() {

    this.tradeMarkText = ApplicationConfiguration.footerTrademarkText;
    this.copyRightText = ApplicationConfiguration.footerCopyRightText;
    this.versionText = BuildInfo.version;
    if (!(window.location.href.includes('multiGamePlay') || window.location.href.includes('match-game') || window.location.href.includes('word-game') || window.location.href.includes('quizitive') ||
      window.location.href.includes('match-game-share') || window.location.href.includes('word-game-share') || window.location.href.includes('quizitive-game-share') || window.location.href.includes('categorize-game')
      || window.location.href.includes('match-game-live-sessions') || window.location.href.includes('word-game-live-sessions') || window.location.href.includes('live-session') || window.location.href.includes('share'))) {
      this.cardService.getUserDetails().subscribe(res => {
        let apiKeyRes = JSON.parse(JSON.stringify(res));
        this.firstName = apiKeyRes.firstName;
        this.lastName = apiKeyRes.lastName;
        this.apikey = apiKeyRes.apikey;
        this.email = apiKeyRes.email;
        setCurrentUserEmailCache(apiKeyRes.email);
        this.userName = apiKeyRes.username;
        UserData.userId = apiKeyRes.userId;//SG-5501
        UserData.iVySessionId = apiKeyRes.iVySessionId;//SG-5501
        this.helperService.activeUserDetails$.next(apiKeyRes);
        localStorage.setItem('userName', JSON.stringify(this.userName));
        if (apiKeyRes.selectedGame) {
          localStorage.setItem('userGame', apiKeyRes.selectedGame);
          localStorage.setItem('gameId', apiKeyRes.selectedGame);
          localStorage.setItem('homePage', JSON.stringify("yes"));
        }
        this.userRole = apiKeyRes.userRole;
        this.helperService.activeUserRole$.next(this.userRole);
        localStorage.setItem('userRole', JSON.stringify(this.userRole));
        this.isCreator = apiKeyRes.creator;
        this.singleOrgAppFlag = true;
        if (!_.isUndefined(UserData.singleOrgApp) && UserData.singleOrgApp)
          this.singleOrgAppFlag = false;
        this.orgId = UserData.organizationId;


        let appRole: any = apiKeyRes.appRole;
        if (!_.isUndefined(appRole) && appRole.length != 0) {
          _.each(appRole, (objs) => {
            let obj: any = objs;
            if (obj == "FLXT")
              this.role_FLXT = obj;
            if (obj == "UMT")
              this.role_UMT = obj;
            if (obj == "ANLT")
              this.role_ANLT = obj;
            if (obj == "APPL")
              this.role_APPL = obj;
            //if(obj=="FEEDB")
            //  this.role_FEEDB=obj;
          });
        }


        this.setLeftMenu();
        this.newSetLeftMenu();
      },
        err => {
          this.getError(err);
        });
    }

    this.role_UMT = localStorage.getItem('Role_UMT');
    this.role_FLXT = localStorage.getItem('Role_FLXT');
    this.role_APPL = localStorage.getItem('Role_APPL');
    this.role_ANLT = localStorage.getItem('Role_ANLT');
    this.role_FEEDB = localStorage.getItem('Role_FEEDB');
    this.subRole_VMT = localStorage.getItem('Role_VMT');
    this.subRole_VAV = localStorage.getItem('Role_VAV');
    if (this.role_UMT != null || this.role_FLXT != null || this.role_APPL != null || this.role_ANLT != null)
      this.rolesFlag = true;
    else
      this.rolesFlag = false;

    if (!this.rolesFlag) {
      this.noAccessMessage = "<h5>Your currently do not have access to any modules. Please contact an administrator.</h5>";
    }

    const adminRegex = /\badmin\b/;
    if (window.location.href.includes('appLibrary') || window.location.href.includes('feedback') || window.location.href.includes('content-management') || (window.location.href.includes('admin') && (adminRegex.test(window.location.href))) || window.location.href.includes('feedback/organizations') || window.location.href.includes('appInformation'))
      if (this.userRole != 'Admin') {
        if (this.role_FLXT == null)
          this.router.navigate(['main/content-management/dashboard']);
        else if (!window.location.href.includes('word-jumble') && (!window.location.href.includes('Match-Game'))
          && (!window.location.href.includes('Memorization')) && (!window.location.href.includes('Phraseology'))) {
          this.router.navigate(['main/content-management/dashboard']);
        }
      }

    let message = new FormControl('', Validators.compose([
      Validators.required
    ]));

    this.noAccessForm = this.fb.group({
      message: message
    });

    this.msgCtrl = this.noAccessForm.controls['message'];
    this.organizationList();
    let abc: any = _.findWhere(UserData.roles, { permission_code: "FEEDB" });

    this.isFEEDB = false;
    this.isANLT = false;

    if (UserData != null && !_.isUndefined(_.findWhere(UserData.roles, { permission_code: "FEEDB" })))
      this.isFEEDB = true;
    if (UserData != null && !_.isUndefined(_.findWhere(UserData.roles, { permission_code: "ANLT" })))
      this.isANLT = true;

    if (!_.isUndefined(UserData.organizationId) && UserData.organizationId != null) {
      this.isTeamMember = true;
      if (this.isFEEDB || this.isANLT)
        this.isUserManagement = true;
      else
        this.isUserManagement = false;

      this.currentOrganization = !_.isUndefined(UserData.currentOrganization) ? UserData.currentOrganization : { "name": "Organization" };
      if (!_.isUndefined(this.currentOrganization))
        this.getImageLogo(this.currentOrganization);
    } else {
      this.isTeamMember = false;
    }
  }

  public clearAppLocalStorage() {
    localStorage.removeItem('Role_FLXT');
    localStorage.removeItem('Role_APPL');
    localStorage.removeItem('Role_FEEDB');
    localStorage.removeItem('Role_ANLT');
  }

  public isManager(): boolean {
    return this.keycloakService.isUserInRole('Manager');
  }

  public isAdmin(): boolean {
    return this.keycloakService.isUserInRole('Admin');
  }

  logmeout() {
    // ***** SG-7344 START *****
    if (this.tabCount > 1) {
      const dialogRef = this.dialog.open(RowDeleteDialogComponent, {
        data: {
          title: 'Warning',
          text: 'You will be logged out of all other active browser tabs automatically. Would you like to proceed?',
          buttonSave: "YES",
          buttonCancle: "CLOSE"
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.performLogout();
        }
      });
    } else {
      this.performLogout();
    }
    // ***** SG-7344 END ***** 
  }

  retainLocalStorageVariables() {
    this.liveSessionStatus = localStorage.getItem('liveSessionStatus');
    this.answerCategory = localStorage.getItem('answerCategory');
    this.previous_route = localStorage.getItem('previous_route');
  }

  regainLocalStorageVariables() {
    if (this.liveSessionStatus !== null) {
      localStorage.setItem('liveSessionStatus', this.liveSessionStatus);
    }
    if (this.answerCategory !== null) {
      localStorage.setItem('answerCategory', this.answerCategory);
    }
    if (this.previous_route !== null) {
      localStorage.setItem('previous_route', this.previous_route);
    }

  }

  performLogout() {
    const currentURL = window.location.href;
    this.retainLocalStorageVariables();
    localStorage.setItem('tabCount', '0');
    localStorage.setItem('logout-event', Date.now().toString());
    if (!currentURL.includes('live-session/')) {
      localStorage.clear();
      this.regainLocalStorageVariables();
      this.keycloakService.logout(currentURL);
    }
    window.addEventListener('storage', async (event) => {
      if (event.key === 'logout-event') {
        if (!currentURL.includes('live-session/')) {
          localStorage.clear();
          this.regainLocalStorageVariables();
          this.keycloakService.logout(currentURL);
        }
      }
    });
  }

  public account() {
    // this will redirect to the keycloak account management page. It will automatically
    // add the link in upper right corner of the account management page to return to
    // route of the application that the user was on before going to the account management page
    this.keycloakService.getKeycloakInstance().accountManagement();
  }

  public getImageLogo(orgId) {
    if (orgId.id) {
      this.cardService.imageLogo(orgId.id).subscribe(res => {
        let dataObject: any = res;
        let data = dataObject;
        UserData.currentOrganization = data;
        this.logoURL = "";
        if (data.logo != "doesnotexist") {
          this.logoURL = data.url + "/logo";
        }
      },
        err => {
          this.getError(err);
        });
    } else {
      this.logoURL = "assets/img/strat-logo.png";
    }
  }

  getData(userName) {
    this.api.get('/organizations/' + localStorage.getItem('organizationId') + '/appRolesAndPermFromUserName?userName=' + userName).subscribe((success) => {
      let appMenu: any = [];
      let isMemberTeams: boolean = false;
      let iscontentManagement: boolean = false;
      let isAppLibrary: boolean = true;
      let isFeedBack: boolean = false;
      let isAnalytics: boolean = false;
      let isConfiguration: boolean = false;//SG-8512

      if (success && success.userGameLevelPermissionMapping) {
        localStorage.setItem('userId', success.userGameLevelPermissionMapping.userId)
      }

      if (success && !_.isUndefined(success.appPermissions)) {
        let appPermission: any = success.appPermissions;
        let dashboard = { label: 'Dashboard', icon: 'fa fa-fw fa-home', routerLink: ['/card'] };
        appMenu.push(dashboard);
        _.each(appPermission, (objs) => {
          let obj = objs;

          if (obj == 0)
            isMemberTeams = true;
          else if (obj == 3)
            isAnalytics = true;
          // iscontentManagement = true;
          // else if (obj == 2)

          else if (obj == 2)
            // isAnalytics = true;
            isAppLibrary = true;

          else if (obj == 4)
            isFeedBack = true;
          
          else if (obj == 1001)//SG-8512
            isConfiguration = true;
        })

        if (isMemberTeams) {
          let userManagementMenu = {
            label: 'Members & Teams', icon: 'fa fa-users',
            routerLink: ['/admin']
          };
          appMenu.push(userManagementMenu);
        }
        if (iscontentManagement) {
          let contentManagement = {
            label: 'Content Management', icon: 'fa fa-list-alt',
            command: (event) => { this.openContentManagement(); },
          };
          appMenu.push(contentManagement);
        }
        if (isAppLibrary) {
          let appLibrary = {
            label: 'App Library', icon: 'fa fa-book',
            command: (event) => { this.openAppLibrary('APPL'); },
          };
          appMenu.push(appLibrary);
        }
        if (isFeedBack) {
          let feedBack = {
            label: 'Feedback', icon: 'fa fa-retweet',
            routerLink: ['/feedback']
          };
          appMenu.push(feedBack);
        }
        let bool = isAnalytics;
        let isShowAnalytics = bool.toString();

        localStorage.setItem('isAnalytic', isShowAnalytics);

        if (isAnalytics) {
          let analytics = {
            label: 'Analytics', icon: 'fa fa-bar-chart',
            routerLink: ['/analytics']
          };
          appMenu.push(analytics);
          let consolidatedAnalytics = {
            label: 'Consolidated Analytics', icon: 'fa fa-bar-chart',
            routerLink: ['/consolidated-analytics']
          };
          appMenu.push(consolidatedAnalytics);
          let lrsAnalytics = {
            label: 'LRS Analytics', icon: 'fa fa-database',
            routerLink: ['/lrs-analytics']
          };
          let email = localStorage.getItem('email');
          if (email && email == "anshuman@rigil.com") {
            appMenu.push(lrsAnalytics);
          }
        }
        //start SG-8512
        if (isConfiguration) {
          let configuration = {
            label: 'Configuration', icon: 'fa-solid fa-gear',
            routerLink: ['/configuration']
          }
          appMenu.push(configuration);
        };
        //end SG-8512
      } else if (_.isUndefined(success.appPermissions) && this.userRole == 'Admin')
        appMenu = this.setMenuData('Admin');
      else if (_.isUndefined(success.appPermissions) && this.userRole == 'Member')
        appMenu = this.setMenuData('Member');

      this.api.sideNavData = appMenu;
      this.helperService.sideNav$.next(this.api.sideNavData);
    });
  }

  setMenuData(data) {
    let appMenu = [];
    let dashboard = { label: 'Dashboard', icon: 'fa fa-fw fa-home', routerLink: ['/card'] };
    appMenu.push(dashboard);
    let userManagementMenu = {
      label: 'Members & Teams', icon: 'fa fa-users',
      routerLink: ['/admin']
    };
    appMenu.push(userManagementMenu);

    let contentManagement = {
      label: 'Content Management', icon: 'fa fa-list-alt',
      command: (event) => { this.openContentManagement(); },
    };
    appMenu.push(contentManagement);
    let appLibrary = {
      label: 'App Library', icon: 'fa fa-book',
      command: (event) => { this.openAppLibrary('APPL'); },
    };
    appMenu.push(appLibrary);
    let feedBack = {
      label: 'Feedback', icon: 'fa fa-retweet',
      routerLink: ['/feedback']
    };
    appMenu.push(feedBack);

    let configurationMenu = {
      label: 'Configuration', icon: 'fa-solid fa-gear',
      routerLink: ['/configuration']
    };
    appMenu.push(configurationMenu);

    if (data == 'Admin') {
      let analytics = {
        label: 'Analytics', icon: 'fa fa-bar-chart',
        routerLink: ['/analytics']
      };
      appMenu.push(analytics);
      let consolidatedAnalytics = {
        label: 'Consolidated Analytics', icon: 'fa fa-bar-chart',
        routerLink: ['/consolidated-analytics']
      };
      appMenu.push(consolidatedAnalytics);
      let lrsAnalytics = {
        label: 'LRS Analytics', icon: 'fa fa-database',
        routerLink: ['/lrs-analytics']
      };
      let email = localStorage.getItem('email');
      if (email && email == "anshuman@rigil.com") {
        appMenu.push(lrsAnalytics);
      }
    }
    return appMenu;
  }

  newSetLeftMenu() {
    if (!(window.location.href.includes('multiGamePlay') || window.location.href.includes('match-game') || window.location.href.includes('word-game') || window.location.href.includes('quizitive') ||
      window.location.href.includes('match-game-share') || window.location.href.includes('word-game-share') || window.location.href.includes('quizitive-game-share') || window.location.href.includes('categorize-game')
      || window.location.href.includes('match-game-live-sessions') || window.location.href.includes('word-game-live-sessions') || window.location.href.includes('live-session') || window.location.href.includes('share')))
      this.getData(this.userName);
  }

  setLeftMenu() {
    this.model = [];
    let appMenu: any = [];
    let dashboard = { label: 'Dashboard', icon: 'fa fa-fw fa-home', routerLink: ['/card'] };
    appMenu.push(dashboard);

    if ((this.userRole == 'Admin' || this.userRole == 'Owner' || this.userRole == 'Member') && this.isTeamMember) {
      let userManagementMenu = {
        label: 'Members & Teams', icon: 'fa fa-users',
        routerLink: ['/admin']
      };
      appMenu.push(userManagementMenu);
    }

    if (this.role_FLXT == 'FLXT') {
      let contentManagement = {
        label: 'Content Management', icon: 'fa fa-list-alt',
        command: (event) => { this.openContentManagement(); },
      };
      appMenu.push(contentManagement);
    }

    if (this.role_APPL == 'APPL') {
      let appLibrary = {
        label: 'App Library', icon: 'fa fa-book',
        command: (event) => { this.openAppLibrary('APPL'); },
      };
      appMenu.push(appLibrary);
    }

    //  if (this.role_FEEDB == 'FEEDB') {
    if (this.isUserManagement && this.role_FEEDB == 'FEEDB') {
      let feedBack = {
        label: 'Feedback', icon: 'fa fa-retweet',
        routerLink: ['/feedback']
      };
      appMenu.push(feedBack);
    }

    if (this.role_ANLT == 'ANLT') {
      let analytics = {
        label: 'Analytics', icon: 'fa fa-bar-chart',
        routerLink: ['/analytics']
      };
      appMenu.push(analytics);
      let consolidatedAnalytics = {
        label: 'Consolidated Analytics', icon: 'fa fa-bar-chart',
        routerLink: ['/consolidated-analytics']
      };
      appMenu.push(consolidatedAnalytics);
      let lrsAnalytics = {
        label: 'LRS Analytics', icon: 'fa fa-database',
        routerLink: ['/lrs-analytics']
      };
      let email = localStorage.getItem('email');
      if (email && email == "anshuman@rigil.com") {
        appMenu.push(lrsAnalytics);
      }
    }

    let configuration = {
      label: 'Configuration', icon: 'fa-solid fa-gear',
      routerLink: ['/configuration']
    };
    appMenu.push(configuration);


    let allExApps = <any>UserData.applications;
    if (allExApps) {
      for (let exApp of allExApps) {
        if (exApp !== "" && (this.userRole == 'Admin' || this.userRole == 'Owner' || this.userRole == 'Member') && (this.role_ANLT == 'ANLT') && this.isUserManagement) {
          let exAppName = {
            label: this.titleCase(exApp.name), icon: exApp.icon,
            url: exApp.outside_url ? exApp.outside_url : window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + exApp.url + '/#' + exApp.url,
            target: '_blank'
          };
          appMenu.push(exAppName);
        }
      }
    }



    // if ((this.userRole == 'Admin' || this.userRole == 'Owner' || this.userRole == 'Member') && (this.role_ANLT == 'ANLT') && this.isUserManagement) {
    //   let alliPads = {
    //     label: 'iPad Management', icon: 'fa fa-tablet',
    //     command: (event) => { this.openAlliPads(); }
    //   }
    //   appMenu.push(alliPads);
    // }

    this.model = appMenu;
    // this.api.sideNavData = appMenu;
    //this.helperService.sideNav$.next(this.api.sideNavData);
  }

  titleCase(string) {
    let sentence = string.toLowerCase().split(" ");
    for (let i = 0; i < sentence.length; i++) {
      sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
    }
    return sentence;
  }

  onMenuButtonClick(event: Event) {
    this.menuButtonClick = true;
    this.menuActive = !this.menuActive;
    event.preventDefault();
  }

  onTopbarMenuButtonClick(event: Event) {
    this.topbarMenuButtonClick = true;
    this.topbarMenuActive = !this.topbarMenuActive;
    event.preventDefault();
  }

  onTopbarItemClick(event: Event, item: Element) {
    this.topbarMenuButtonClick = true;

    if (this.activeTopbarItem === item) {
      this.activeTopbarItem = null;
    } else {
      this.activeTopbarItem = item;
    }
    event.preventDefault();
  }

  onTopbarItemClick1(item: Element) {
    this.topbarMenuButtonClick = true;

    if (this.activeTopbarItem === item) {
      this.activeTopbarItem = null;
    } else {
      this.activeTopbarItem = item;
    }
  }

  onTopbarSubItemClick(event) {
    event.preventDefault();
  }

  onLayoutClick() {
    if (!this.menuButtonClick && !this.menuClick) {
      if (this.menuMode === 'horizontal') {
        this.resetMenu = true;
      }

      if (this.isMobile() || this.menuMode === 'overlay' || this.menuMode === 'popup') {
        this.menuActive = false;
      }

      this.menuHoverActive = false;
    }

    if (!this.topbarMenuButtonClick) {
      this.activeTopbarItem = null;
      this.topbarMenuActive = false;
    }

    this.menuButtonClick = false;
    this.menuClick = false;
    this.topbarMenuButtonClick = false;
  }

  onMenuClick(label) {
    this.menuClick = true;
    this.resetMenu = false;
    if (label == "Content Management") {
      if (UserData.isRouting)
        this.callContentManagment("");
    } else
      UserData.isRouting = false;
  }

  isMobile() {
    return window.innerWidth < 1025;
  }

  isHorizontal() {
    return this.menuMode === 'horizontal';
  }

  isTablet() {
    const width = window.innerWidth;
    return width <= 1024 && width > 640;
  }

  public admin() {
    this.router.navigate(['/admin']);
  }

  public openFlexTabe = function () {
    this.CMSelectedTab = '';
    this.router.navigate(['/content-management']);
  }

  public openFeedback = function () {
    this.router.navigate(['/feedback']);
  }

  public openMap = function () {
    this.router.navigate(['/airport']);
  }

  public openVis = function () {
    this.router.navigate(['/Vis/vis']);
  }

  public accountInfo() {
    this.router.navigate(['/Account']);
  }

  public get sanitizedHtmlProperty(): SafeHtml {
    return this._sanitizer.sanitize(SecurityContext.HTML, this.noAccessMessage);
  }

  public noAccessNotification(message) {
    let dataToShare: any = {};
    dataToShare.userEmail = this.email;
    dataToShare.firstName = this.firstName;
    dataToShare.lastName = this.lastName;
    dataToShare.message = message.message;
    this.cardService.sendNoAccessNotification(dataToShare).subscribe(res => {
      let dataObject: any = res;
      let apiKeyRes = dataObject;
      this.apikey = apiKeyRes.apikey;
    },
      err => {
        this.getError(err);
      });
  }

  public openAppLibrary(app_code) {
    this.cardService.getSubApps(this.userName, app_code).subscribe(res => {
      const dataObject: any = res;
      localStorage.setItem('subApps', JSON.stringify(dataObject));

      if (!_.isEmpty(dataObject)) {
        this.router.navigate(['/appLibrary']);
      }
    },
      err => {
        this.getError(err);
      });
  }

  public openContentManagement() {
    this.CMSelectedTab = '';
    this.router.navigate(['/content-management']);
  }

  public changeLayout(layout) {
    const layoutLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('layout-css');
    layoutLink.href = 'assets/layout/css/layout-' + layout + '.css';
  }

  public changeTheme(theme) {
    const themeLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('theme-css');
    themeLink.href = 'assets/theme/theme-' + theme + '.css';
  }

  public openAnalytics() {
    this.router.navigate(['/analytics']);
  }

  public openAlliPads() {
    this.router.navigate(['/iPadManagement']);
  }

  public organizationList() {
    this.commonAPIService.getOrganizations().subscribe(res => {
      localStorage.setItem('organizationss', JSON.stringify(res));
      let dataList = res
      this.organizationDataList = dataList;
      this.gameOrder = (this.organizationDataList && this.organizationDataList[0]) ? this.organizationDataList[0].gameOrder : undefined;
      let userData: any = {};
      userData.id = null;
      userData.name = _.isUndefined(this.userName) ? this.email : this.userName;
      this.organizationDataList.unshift(userData);
      if (!JSON.parse(localStorage.getItem('isUserManagement'))) {
        _.each(this.organizationDataList, (objs, key) => {
          let obj: any = objs;
          if (key == 0)
            obj.isRight = true;
          else
            obj.isRight = false
        });
      } else {
        if (!_.isUndefined(this.organizationDataList) && this.organizationDataList.length != 0) {
          _.each(this.organizationDataList, (objs) => {
            let obj: any = objs;
            if (!_.isUndefined(UserData.organizationId) && obj.id == UserData.organizationId)
              obj.isRight = true;
            else
              obj.isRight = false
          });

        }
      }
      if (this.organizationDataList.length == 1 && this.organizationDataList[0].id == null) {
        this.isUserManagement = false;
        this.showAnalytics = false;
        _.each(this.organizationDataList, (objs, key) => {
          let obj: any = objs;
          if (key == 0)
            obj.isRight = true;
          else
            obj.isRight = false
        });
      }
    },
      err => {
        this.getError(err);
      });
  }

  showAnalytics = false;

  //SG-6756 start
  resetInactivityTimer() {
    clearTimeout(this.inactivityTimeout);
    this.inactivityTimeout = setTimeout(() => {
      const logoutEvent = localStorage.getItem('logout-event');
      //if (!logoutEvent) {
      localStorage.setItem('logout-event', Date.now().toString());
      // }
      this.api.notifyError('Your session got expired, please login again to continue.');

      // window.alert("Your session got expired, please login again to continue.")
      if(this.helperService.getIsMobileDevice()){
        this.reactmobileservice.responseFromWeb('Your session got expired, please login again to continue.', false, true, false);
      } else {
        this.doLogout();
      }

    }, this.MAX_INACTIVITY_SECONDS * 1000); // Convert to milliseconds
    // this.MAX_INACTIVITY_SECONDS * 1000);
  }
  @HostListener('window:storage', ['$event'])
  onStorageChange(event: StorageEvent) {
    if (event.key === 'logout-event') {
      const currentURL = window.location.href;
      if (!currentURL.includes('live-session/')) {
        if(this.helperService.getIsMobileDevice()) {
          this.reactmobileservice.responseFromWeb('Storage Changed', false, true, false); 
        } else {
          this.doLogout();
        }
      }
    }
  }
  //SG-6756 end
  // @HostListener('document:mousemove')
  // @HostListener('document:keydown')
  // onUserActivity() {
  //   this.resetInactivityTimer();
  // }

  public selectOrganization(data) {
    UserData.currentOrganization = data
    UserData.organizationId = data.id
    this.currentOrganization = data;
    if (!_.isUndefined(this.currentOrganization))
      this.getImageLogo(this.currentOrganization);
    this.refreshData();

    if (data.id != null) {
      localStorage.setItem('isUserManagement', JSON.stringify(true));
      this.showAnalytics = true;
    } else {
      this.showAnalytics = false;
    }

    this.isFEEDB = false;
    this.isANLT = false;

    if (UserData != null && !_.isUndefined(_.findWhere(UserData.roles, { permission_code: "FEEDB" })))
      this.isFEEDB = true;
    if (UserData != null && !_.isUndefined(_.findWhere(UserData.roles, { permission_code: "ANLT" })))
      this.isANLT = true;

    if (!_.isUndefined(UserData.organizationId) && UserData.organizationId != null && (this.isFEEDB || this.isANLT)) {
      this.isUserManagement = true;
      this.showAnalytics = true;
    } else
      this.isUserManagement = false;

    if (!_.isUndefined(UserData.organizationId) && UserData.organizationId != null) {
      this.isTeamMember = true;
      this.showAnalytics = true;
    } else
      this.isTeamMember = false;

    _.each(this.organizationDataList, (objs) => {
      let obj: any = objs;
      if (data.id == obj.id)
        obj.isRight = true;
      else
        obj.isRight = false;
    })

    // this.router.navigate(['/card']);
    this.router.navigate(['main/content-management/dashboard']);
  }

  public getError(err) {

  }

  organization() {
    this.router.navigate(['/organization']);
  }

  //start SG-8399
  private checkForDevice() {
    this.reactmobileservice.responseFromWeb("checkForDevice function start", false, false, true); 
    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams) {
      const device = urlParams.get('device');
      const nickName= urlParams.get('nickName');
      const token= urlParams.get('token');
      const radamKey= urlParams.get('randomKey');
      const isOpenIvy =  urlParams.get('isOpenIvy');
      if(device && nickName) {
        this.helperService.setDetailsFromURL({ 
          device: device, 
          nickName: nickName, 
          isOpenIvy: isOpenIvy
        });
      }
      if(device && token && radamKey) {
        this.helperService.setDetailsFromURL({ 
          device: device, 
          token: token, 
          radamKey: radamKey,
          isOpenIvy: isOpenIvy
        });
      }
    } else {
      this.reactmobileservice.responseFromWeb("urlParams not found", false, false, true); 
    }
    this.reactmobileservice.responseFromWeb("local storage data saved: " + localStorage.getItem('UserDetailsDataFromUrl') as string, false, false, true); 
    let loginDetails = this.helperService.getMobileLoginData();
    let isMobile = this.helperService.getIsMobileDevice();
    if(loginDetails && loginDetails.nickName && isMobile) {
      this.reactmobileservice.responseFromWeb("nick name login start (checkUserAuthForNickNameUser)", false, false, true); 
      this.authUserService.checkUserAuthForNickNameUser(loginDetails.nickName).subscribe({
        next: (response: any) => {
          this.reactmobileservice.responseFromWeb('nick name login success response: ' + response ? JSON.stringify(response): '', false, false, true); 
          if (response && response.access_token) {
            UserData.token = response.access_token;
            UserData.mobileUserData = response;
            this.tokenId = response.access_token;
            try {
              const payload = JSON.parse(atob(response.access_token.split('.')[1]));
              this.firstName = payload.given_name || '';
              this.lastName = payload.family_name || '';
              this.email = payload.email || '';
              this.userName = payload.preferred_username || '';
              localStorage.setItem('email', this.email);
            } catch (e) {
              this.reactmobileservice.responseFromWeb('catch error: ' + JSON.stringify(e), false, false, true); 
            }
            this.onLoggedin();
          } else {
            console.error('no response');
            this.reactmobileservice.responseFromWeb('Session Expired', false, true, false); 
          }
        },
        error: (err) => { 
          var msg = err?.error ? JSON.stringify(err.error) : err ? JSON.stringify(err) : '';
          this.reactmobileservice.responseFromWeb(msg, true, true, false);
        }
      });
    } else if(isMobile && loginDetails.token && loginDetails.radamKey) {
      this.authUserService.checkUserAuthForRegisteredUser(loginDetails.token, loginDetails.radamKey)
      .subscribe({
        next: (response: any) => {
          if (response && response.access_token) {
            UserData.token = response.access_token;
            UserData.mobileUserData = response;
            this.tokenId = response.access_token;
            try {
              const payload = JSON.parse(atob(response.access_token.split('.')[1]));
              this.firstName = payload.given_name || '';
              this.lastName = payload.family_name || '';
              this.email = payload.email || '';
              this.userName = payload.preferred_username || '';
              localStorage.setItem('email', this.email);
            } catch (e) {
              console.error('Failed to parse mobile token payload', e);
            }
            this.onLoggedin();
          } else {
            this.reactmobileservice.responseFromWeb('Session Expired', false, true, false); 
          }
        },
        error: (err) => { 
          var msg = err?.error? JSON.stringify(err.error) : err ? JSON.stringify(err) : '';
          this.reactmobileservice.responseFromWeb(msg, true, true, false);
        }
      });
    } else {
      this.helperService.removeDetailsFromURL();
    }
  }
  //end SG-8399 
} 